import {Injectable} from '@angular/core';
import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Coupon} from './model';

export interface CouponState extends EntityState<Coupon> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Coupon' })
export class Store extends EntityStore<CouponState> {

  constructor() {
    super();
  }

}
